import { Injectable } from '@angular/core';
import { createAuthorizationHeader } from '../utils/headers';
import { GlobalService } from '../global.config';
import { HttpClient } from '@angular/common/http';
import { DateInterval } from '../model/date-interval.model';
import { Observable } from 'rxjs';

export class TokenLutDto{
  deviceid : string;
  username :string;
  token: string;
  language: string;
  lastTime: Date;
  platform?: string;
}
@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  selectedTab : String;
  constructor(private _http: HttpClient, private globalService:GlobalService) {
    this.selectedTab = "realtime";
  }

  getEventsByDeviceAndDateRange(
    deviceId: number,
    dateInterval: DateInterval,
    includeArchive = true
  ): Observable<any> {
    const headers = createAuthorizationHeader();
    const query = includeArchive ? '?includeArchive=true' : '';
    return this._http.post(
      this.globalService.dns + 'events/device/' + deviceId + '/date-range' + query,
      {
        startDate: dateInterval.startDate,
        endDate: dateInterval.endDate
      },
      { headers }
    );
  }

}
